import { DatePicker } from 'baseui/datepicker'

const SDDatePicker = ({ ...rest }) => {
  return <DatePicker {...rest} />
}

export default SDDatePicker
